module.exports = __webpack_public_path__ + "img/go-apoint-btn.d749608c.png";